// extracted by mini-css-extract-plugin
export default {"container":"TagPostV2__container___vbhFc"};